import React from 'react';

const DecisionMadeMessage = () => {
  return (
    <>
      <h3>Your decision has been submitted!</h3>

      <p>Regardless of whether you chose to accept your enrollment offer or not, you'll receive an email soon with more information and next steps. If you need to make changes to your decision or have any additional questions, please reach out to our Enrollment team at <a href="mailto:enrollment@launchcode.org">enrollment@launchcode.org</a>.</p>
    </>
  )
};

export default DecisionMadeMessage;
